import {LoadingBar} from 'view-design'
import createRoutes from '@/utils/createRoutes'
import {getBaseInfo} from '@/api'
import store from '@/store'
import router from './router'
import {getDocumentTitle, resetTokenAndClearUser} from './utils'

// 是否有菜单数据
let hasMenus = false
router.beforeEach(async (to, from, next) => {
    document.title = getDocumentTitle(to.meta.title)
    LoadingBar.start()
    if (sessionStorage.getItem('token')) {
        if (to.path === '/login') {
            next({path: '/'})
        } else if (hasMenus) {
            next()
        } else {
            try {
                const {data} = await getBaseInfo()
                const routes = createRoutes(data.menu)
                sessionStorage.setItem("merchantInfo", data.merchantInfo)
                sessionStorage.setItem("storeInfo", data.storeInfo)
                // 动态添加路由
                routes.forEach(route => {
                    router.addRoute(route)
                })
                store.commit('setMenus', data.menu)
                hasMenus = true
                next({path: to.path || '/', query: to.query})
            } catch (error) {
                resetTokenAndClearUser()
                next(`/login?redirect=${to.path}`)
            }
        }
    } else {
        hasMenus = false
        if (to.path === '/login') {
            next()
        } else {
            next(`/login?redirect=${to.path}`)
        }
    }
})

router.afterEach(() => {
    LoadingBar.finish()
})
